import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { adminMainUrl } from "../../../Config";
import Cookies from "js-cookie";
import AccountPagination from "../../Masters/AccountMaster/GroupMaster/AccountPagination";
import { useLocation, useNavigate } from "react-router-dom";

const JobClosingOpenShipmentsForClosing = () => {
  const token = Cookies.get("token");
  const user_id = Cookies.get("flexichain_user_id");

  const [openShipmentSearch, setOpenShipmentSearch] = useState({
    from_date: "",
    to_date: "",
    branch: "",
    docket: "",
    shipment_status: "",
    service_type: "",

    // open shipment data
    open_shipment: [],
  });
  const [tableData, setTableData] = useState([]);

  const [ReceiptVoucherCurrentPage, setReceiptVoucherCurrentPage] = useState(1);
  const [ReceiptVoucherTotalPage, setReceiptVoucherTotalPage] = useState(0);

  const navigate = useNavigate();

  const location = useLocation();
  const urlString = window.location.href;
  const url = new URL(urlString);
  const path = url.pathname.slice(1);
  const searchParams = url.search;
  const q = path + searchParams;
  const queryParams = new URLSearchParams(location.search);

  const onValueChange = (e) => {
    const { name, type, value, checked } = e.target;

    setOpenShipmentSearch((pre) => ({
      ...pre,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const ClearForm = () => {
    setOpenShipmentSearch({
      from_date: "",
      to_date: "",
      branch: "",
      docket: "",
      shipment_status: "",
      service_type: "",

      // open shipment data
      open_shipment: [],
    });
  };

  const handleCheckbox = (row, checked) => {
    let updated = [...openShipmentSearch.open_shipment];

    if (checked) {
      updated.push(row);
    } else {
      updated = updated.filter((item) => item.id !== row.id);
    }
    setOpenShipmentSearch((prev) => ({
      ...prev,
      open_shipment: updated,
    }));
  };

  // SELECT ALL
  const handleSelectAll = () => {
    setOpenShipmentSearch((prev) => ({
      ...prev,
      open_shipment: [...tableData], // select all rows
    }));
  };

  // CLOSE SELECTED
  const handleCloseSelected = () => {
    alert(
      "Selected Shipments:\n" +
        JSON.stringify(openShipmentSearch.open_shipment, null, 2),
    );
  };

  const searchReceiptVoucher = async (
    token,
    user_id,
    { page, from_date, to_date, shipment_status, service_type },
  ) => {
    // console.log("data", openShipmentSearch);
    if (from_date > to_date) {
      toast.error("From date cannot be greater than To date");
      return;
    }
    const config = {
      headers: {
        "auth-token": token,
        user_id: user_id,
        "Content-Type": "application/json",
      },
    };

    let apiUrl = `${adminMainUrl}/api/account/cost-and-revenue-finalization-search`;
    const queryParams = [];
    if (page) queryParams.push(`page=${page}`);
    if (from_date) queryParams.push(`from_date=${from_date}`);
    if (to_date) queryParams.push(`to_date=${to_date}`);
    if (shipment_status) queryParams.push(`shipment_status=${shipment_status}`);
    if (service_type) queryParams.push(`service_type=${service_type}`);

    if (queryParams.length > 0) {
      apiUrl += `?${queryParams.join("&")}`;
    }
    try {
      const res = await axios.get(apiUrl, config);
      // console.log("res",res.data.data)
      setTableData(res.data.data);
      setReceiptVoucherCurrentPage(res.data.pagination.currentPage || 1);
      setReceiptVoucherTotalPage(res.data.pagination.totalPages || 0);
    } catch (error) {
      console.error("Error fetching receipt vouchers:", error);
    }
  };

  const { from_date, to_date, shipment_status, service_type } =
    openShipmentSearch;

  const searchHandler = () => {
    if (from_date > to_date) {
      toast.error("From date cannot be greater than To date");
      return;
    }

    searchReceiptVoucher(token, user_id, {
      from_date,
      to_date,
      shipment_status,
      service_type,
    });
  };

  useEffect(() => {
    if (token && user_id) {
      searchReceiptVoucher(token, user_id, { page: 1 });
    } else {
      toast.error("Please login to continue.");
      navigate(`/login?burl=${encodeURIComponent(q)}`);
    }
  }, [token, user_id]);

  return (
    <>
      <style>
        {`
          .padding-pt-9 {
            padding: 10px;
          }
        `}
      </style>

      <div className="card p-4">
        <h5 className="fw-semibold mb-3">Search Open Shipments</h5>
        <div className="row">
          {/* from_date */}
          <div className="col-12 col-sm-4 col-md-3 mb-4">
            <label className="form-label fw-medium">From Date</label>
            <input
              type="date"
              name="from_date"
              className="form-control bg-light"
              placeholder="Enter from date"
              onChange={onValueChange}
              value={openShipmentSearch.from_date}
            />
          </div>

          {/* to_date */}
          <div className="col-12 col-sm-4 col-md-3 mb-4">
            <label className="form-label fw-medium">To Date</label>
            <input
              type="date"
              name="to_date"
              className="form-control bg-light"
              placeholder="Enter to date"
              onChange={onValueChange}
              value={openShipmentSearch.to_date}
            />
          </div>

          {/* branch mismatch input */}
          {/* <div className="col-12 col-sm-4 col-md-3 mb-4">
            <label className="form-label fw-medium">Branch </label>
            <select
              name="branch"
              className="form-select bg-light padding-pt-9"
              value={openShipmentSearch.branch}
              onChange={onValueChange}
            >
              <option value="">Select branch </option>
              <option value="branch">branch 1</option>
            </select>
          </div> */}

          {/* docket mismatch input */}
          {/* <div className="col-12 col-sm-4 col-md-3 mb-4">
            <label className="form-label fw-medium">Docket/Job ID </label>
            <input
              type="text"
              name="docket"
              className="form-control bg-light"
              value={openShipmentSearch.docket}
              onChange={onValueChange}
              placeholder="docket "
            />
          </div> */}

          {/* shipment_status */}
          <div className="col-12 col-sm-4 col-md-3 mb-4">
            <label className="form-label fw-medium">Shipment Status </label>
            <select
              name="shipment_status"
              className="form-select bg-light padding-pt-9"
              value={openShipmentSearch.shipment_status}
              onChange={onValueChange}
            >
              <option value="">Select Shipment Status</option>
              <option value="In-Transit">In Transit</option>
              <option value="Delivered">Delivered</option>
            </select>
          </div>

          {/* service_type */}
          <div className="col-12 col-sm-4 col-md-3 mb-4">
            <label className="form-label fw-medium">Service Type </label>
            <select
              name="service_type"
              className="form-select bg-light padding-pt-9"
              value={openShipmentSearch.service_type}
              onChange={onValueChange}
            >
              <option value="">Select service type </option>
              <option value="Air Freight">Air Freight</option>
              <option value="Sea Freight">Sea Freight</option>
              <option value="Road Transport">Road Transport</option>
              <option value="Rail Transport">Rail Transport</option>
              <option value="Express">Express</option>
              <option value="Standard">Standard</option>
            </select>
          </div>

          {/* ACTION BUTTONS */}
          <div className="d-flex flex-wrap gap-2 mt-3">
            <button
              onClick={() => searchHandler()}
              className="btn btn-primary px-4"
            >
              <i className="fas fa-search me-1"></i> Search
            </button>

            <button
              onClick={() => ClearForm()}
              className="btn btn-light border px-4"
            >
              <i className="fas fa-undo me-1"></i> Clear
            </button>
            {/* SELECT ALL BUTTON */}
            <button className="btn btn-danger px-4" onClick={handleSelectAll}>
              <i className="fa-solid fa-check-double me-2"></i> Select All
            </button>

            {/* CLOSE SELECTED BUTTON */}
            <button
              className="btn btn-danger px-4"
              onClick={handleCloseSelected}
            >
              <i className="fa-solid fa-file me-2"></i> Close Selected
            </button>

            <button className="btn btn-light border px-4">
              <i class="fa-solid fa-file-export"></i> Export
            </button>
          </div>
        </div>
      </div>

      <div className="card p-4 mt-3">
        <h5 className="fw-semibold mb-3">Open Shipments</h5>

        {/*  Make TABLE Responsive  */}
        <div className="table-responsive">
          <table className="table align-middle">
            <thead>
              <tr>
                <th>Close</th>
                <th>Shipment NO</th>
                <th>Date</th>
                <th>Customer</th>
                <th>Origin</th>
                <th>Destination</th>
                <th>Service</th>
                <th>Weight (KG)</th>
                <th>Revenue</th>
                <th>Cost</th>
                <th>Profit</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {tableData.map((row) => (
                <tr key={row.id}>
                  {/* Checkbox */}
                  <td>
                    <input
                      type="checkbox"
                      checked={openShipmentSearch.open_shipment.some(
                        (item) => item.id === row.id,
                      )}
                      onChange={(e) => handleCheckbox(row, e.target.checked)}
                    />
                  </td>

                  <td>{row.shipment_no}</td>
                  <td>{row.shipment_date.split("T")[0]}</td>
                  <td>{row.customer}</td>
                  <td>{row.origin}</td>
                  <td>{row.destination}</td>

                  {/* Service Pill */}
                  <td>
                    <span className="badge rounded-pill bg-light text-dark px-3 py-2">
                      {row.service_type}
                    </span>
                  </td>

                  <td>{row.weight}</td>
                  <td>{row.base_revenue}</td>
                  <td>{row.base_cost}</td>

                  {/* Profit */}
                  <td className="text-success fw-semibold">
                    {row.gross_profit}
                  </td>

                  {/* Status */}
                  <td>
                    <span
                      className={`badge px-3 py-2 ${
                        row.status === "Delivered"
                          ? "bg-success-subtle text-success"
                          : "bg-primary-subtle text-primary"
                      }`}
                    >
                      {row.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <AccountPagination
          currentPage={ReceiptVoucherCurrentPage}
          totalPages={ReceiptVoucherTotalPage}
          onPageChange={(page) => {
            searchReceiptVoucher(token, user_id, {
              page,
              from_date,
              to_date,
              shipment_status,
              service_type,
            });
          }}
        />
      </div>
    </>
  );
};

export default JobClosingOpenShipmentsForClosing;
